import { METERS_PER_SEC_TO_MPH_FACTOR } from 'features/weatherStations/weatherStations.constants';

export const convertMphToMetersPerSec = (mph: number): number =>
  mph / METERS_PER_SEC_TO_MPH_FACTOR;
